<div class="top-bar">
  <mat-icon class="close-icon" mat-dialog-close>close</mat-icon>
</div>
<h2 class="popup-title">Select your business type.</h2>

<div class="options-container">
  <div class="option-card" *ngFor="let option of options" [class.active]="selectedOption === option.key"
    (click)="selectOption(option.key)">
    <div class="icon-wrapper">
      <img [src]="option.img" alt="" />
    </div>

    <h3 class="card-title">{{ option.title }}</h3>
    <p class="card-desc">{{ option.desc }}</p>
  </div>
</div>

<div class="actions">
  <button class="next-btn" [disabled]="!selectedOption" (click)="onNext()">Next</button>
</div>